// src/components/cart/EmptyCart.jsx
import React from 'react';
import { Link } from 'react-router-dom';

const EmptyCart = () => (
  <div className="empty-cart">
    <div className="empty-cart-icon">🛒</div>
    <h2>Your cart is empty</h2>
    <p>Looks like you haven't added any Nepali stories yet.</p>
    <Link to="/shop" className="empty-cart-cta">
      Discover Books
    </Link>
  </div>
);

export default EmptyCart;